import React, {CSSProperties} from 'react';
import cn from 'classnames';

import {ISkeletonProps} from './ISkeleton';

// eslint-disable-next-line no-restricted-imports -- legacy SCSS, CSS Modules migration pending
import './Skeleton.scss';

const Skeleton = ({as = 'span', classNames, width, height, absolute, source}: ISkeletonProps) => {
	const conditionalProps: Record<string, any> = {};
	const TagName = as;
	const style: CSSProperties = {};

	// Used for debugging purposes
	if (source) {
		conditionalProps['data-source'] = source;
	}

	if (width) {
		style.width = width;
	}

	if (height) {
		style.height = height;
	}

	if (Object.keys(style || {}).length > 0) {
		conditionalProps.style = style;
	}

	return (
		<TagName
			className={cn('skeleton-wrapper', classNames, {
				'skeleton-wrapper--absolute': absolute,
			})}
			{...conditionalProps}
		>
			<span className="skeleton" />
		</TagName>
	);
};

export default Skeleton;
